module.exports = __webpack_public_path__ + "img/paint-roller.cad12d63.svg";